// src/App.js
import { Routes, Route } from 'react-router-dom';
import InventoryApp from './InventoryApp.jsx';
import Login from './Login.jsx';
import { RequireAuth } from './AuthContext.js';
import AdminUsersScreen from './AdminUsersScreen.jsx';
import AdminLogin from './AdminLogin.jsx';

export default function App() {
  return (
    <Routes>
      {/* Public login route */}
      <Route path="/login" element={<Login />} />

      {/* Protected inventory checklist */}
      <Route
        path="/"
        element={
          <RequireAuth>
            <InventoryApp />
          </RequireAuth>
        }
      />
      {/* Admin “Add Users” screen */}
      <Route
        path="/admin"
        element={
          <RequireAuth>
            <AdminUsersScreen />
          </RequireAuth>
        }
      />
      <Route
        path="/admin-login"
        element={<AdminLogin />} />
    </Routes>
  );
}
